var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(13.0596 4)",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.72C3.63 0 3.63 0.43 4.24 1.28C4.47322 1.70733 4.82704 2.05656 5.25738 2.28418C5.68771 2.51179 6.17552 2.60772 6.66 2.56C8.18 2.56 9.66 2.56 10 4.7",
    transform: "translate(5.7002 11.8203)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62507 3.00579C4.62507 3.00579 8.82012 4.49513 12.0978 1.85059C15.1557 -0.603004 17 -0.202028 17 0.695397C17 1.59282 14.9455 3.30175 13.9517 4.13234C12.9578 4.96294 9.62282 6.92008 8.543 6.99646C7.46318 7.07284 3.76504 5.889 2.67566 5.76489C1.78149 5.68529 0.880537 5.73351 0 5.90809",
    transform: "translate(6 13)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07 0H0.84C0.376081 0 0 0.37608 0 0.84V9.77C0 10.2339 0.376081 10.61 0.84 10.61H3.07C3.53392 10.61 3.91 10.2339 3.91 9.77V0.84C3.91 0.37608 3.53392 0 3.07 0Z",
    transform: "translate(1 9.55078)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.35 0.700001C0.5433 0.700001 0.7 0.5433 0.7 0.35C0.7 0.156701 0.5433 0 0.35 0C0.1567 0 0 0.156701 0 0.35C0 0.5433 0.1567 0.700001 0.35 0.700001Z",
    transform: "translate(3.26953 17.7305)",
    stroke: "#1E334E",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueIcon);
export default __webpack_public_path__ + "static/media/Revenue_Icon.af5b9f759fdd038f03f249570746d3de.svg";
export { ForwardRef as ReactComponent };